
export const COLONNE_TROISIEME = 2

export const colonneCulture = (codeCulture, codeCultureUne, codeCultureDeux) => {
  if (codeCulture != null && codeCulture === codeCultureUne) {
    return 0
  }
  if (codeCulture != null && codeCulture === codeCultureDeux) {
    return 1
  }
  return COLONNE_TROISIEME
}

export const TABLEAU_ERREUR_PAR_RUBRIQUE = {
  PRODUIT: 'hasErreurProduit',
  DENSITE_SEMIS: 'hasErreurIntrant',
  AUTRE_CHARGE_SPECIFIQUE: 'hasErreurAutresCharges'
}

export const aMemeValeurAdmin = (parametre) => {
  const bornes = parametre?.valeurAdmin
  if (bornes == null) {
    return false
  }
  return parametre.valeurDefaut === bornes.minimum && parametre.valeurDefaut === bornes.maximum
}
